import { MutationTree } from 'vuex'
import { OtherEquipmentConnectionState } from './types'
import { idGenerator } from '@/services'

export const mutations: MutationTree<OtherEquipmentConnectionState> = {
  RESET(state) {
    state.requestId = idGenerator.getNewWebReference()
  }
}
